const SUPABASE_URL = 'https://guesfwurjogtvcrmtwpl.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd1ZXNmd3Vyam9ndHZjcm10d3BsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE0ODA2MTgsImV4cCI6MjA1NzA1NjYxOH0.WfbqfKxlYf-z-NC4LwgJK7kDc-AxwgKeYMvgd5jQlcQ';
const SUPABASE_KEY = SUPABASE_ANON_KEY;

const LOGIN_URL = '/crm-login.html';
let _refreshing = null;
let _redirected = false;

function getToken() {
  return localStorage.getItem('airjump_token') || null;
}

function redirectToLogin() {
  if (_redirected) return;
  _redirected = true;
  // Only redirect if we're in the main window (not an iframe)
  if (window.top === window.self) {
    window.location.href = LOGIN_URL;
  }
}

async function refreshToken() {
  if (_refreshing) return _refreshing;
  const rt = localStorage.getItem('airjump_refresh_token');
  if (!rt) return false;

  _refreshing = (async () => {
    try {
      const res = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, {
        method: 'POST',
        headers: { apikey: SUPABASE_ANON_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh_token: rt }),
      });
      if (!res.ok) return false;
      const data = await res.json();
      if (data.access_token) {
        localStorage.setItem('airjump_token', data.access_token);
        if (data.refresh_token) localStorage.setItem('airjump_refresh_token', data.refresh_token);
        return true;
      }
      return false;
    } catch { return false; }
    finally { _refreshing = null; }
  })();
  return _refreshing;
}

async function authFetch(url, opts = {}) {
  let token = getToken();

  // No token at all → redirect to login
  if (!token) {
    redirectToLogin();
    return new Response(null, { status: 401 });
  }

  const makeHeaders = (t) => ({
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${t}`,
    'Content-Type': 'application/json',
    ...opts.headers,
  });

  let res = await fetch(url, { ...opts, headers: makeHeaders(token) });

  if (res.status === 401) {
    const refreshed = await refreshToken();
    if (refreshed) {
      token = getToken();
      res = await fetch(url, { ...opts, headers: makeHeaders(token) });
    } else {
      // Refresh failed → session expired, redirect to login
      redirectToLogin();
    }
  }
  return res;
}

export async function sb(path, { method = 'GET', body, prefer } = {}) {
  const res = await authFetch(`${SUPABASE_URL}/rest/v1/${path}`, {
    method,
    headers: { Prefer: prefer || 'return=representation' },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) return null;
  const text = await res.text();
  if (!text) return null;
  return JSON.parse(text);
}

export { SUPABASE_URL, SUPABASE_KEY, SUPABASE_ANON_KEY, authFetch };
